import { render } from "./sixTea.vue?vue&type=template&id=2a0a53dd"
import script from "./sixTea.vue?vue&type=script&lang=js"
export * from "./sixTea.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__